import { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import AssessmentPlanningForm from "./AssessmentPlanningForm";

import { SECOND_ROUND_DROPDOWN_ACTIVE } from '../../fastConstants.js';

export default function AssessmentPlanningDialog(props) {

    const handleClose = () => {
        props.handleCloseDialog()
    }

    const handleCancel = () => {
        props.handleCancelDialog()
    }

    const incompleteStepsExist = (programId) => {
        if (!props.step1CompletionData[programId] ||
            !props.step1CompletionData[programId].completed) {
            return true
        }
        if (!props.step2CompletionData[programId] ||
            !props.step2CompletionData[programId].completed) {
            return true
        }
        if (!props.step3CompletionData[programId] ||
            !props.step3CompletionData[programId].completed) {
            return true
        }
        if (!props.step4CompletionData[programId] ||
            !props.step4CompletionData[programId].completed) {
            return true
        }

        return false
    }

    const isFormDisabled = (programId, stepTab1Data) => {
        if (SECOND_ROUND_DROPDOWN_ACTIVE === true && stepTab1Data.s5q30 !== 'yes') {
            return true
        }
        if (incompleteStepsExist(programId)) {
            return true
        }

        if (programId) {
            if ((programId in props.stepCompletionData) &&
                props.stepCompletionData[programId]?.completed) {
                return true
            }
        }
        return false
    }
    
    return (
        <Modal size="lg" show={props.showModal} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Design and Plan Changes - Edit</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="text-center">
                    <h2>Design and Plan Changes</h2>
                    <div className="p-3">
                        <p style={{"textIndent":"50px"}}>
                            Start by using the tab on the left labeled ‘Plan Changes’ 
                            to describe the planned change(s) that will target improvement 
                            of at least one outcome for each program (this area can be left 
                            blank for the remaining outcomes in each program). Then, use 
                            the tab on the right labeled ‘Plan assessment’ to record plans 
                            for conducting assessment a second time.  For each Gen Ed area, 
                            all outcomes (Gen Ed Essential Skills) mapped to the current theme 
                            are expected to be assessed a second time, not just the outcome(s) 
                            targeted by the change. Please review background information about 
                            Designing and Planning Changes before continuing: <a href="https://rise.articulate.com/share/FcrbFC3QbiBCGEVeQfetTjURoEU7v4uR" target="_blank">View</a>
                        </p>
                    </div>
                    { incompleteStepsExist(props.selectedProgram?.programId)
                        ? <div className="pb-3">
                            <span className="text-danger">Previous step(s) must be completed before this step can be completed.</span>
                          </div>
                        : <></>
                    }
                </div>
                <div className="mx-5">
                    <AssessmentPlanningForm 
                        department={props.department}
                        selectedProgram={props.selectedProgram}
                        selectedLearningOutcome={props.selectedLearningOutcome}
                        learningOutcomes={props.learningOutcomes}
                        theme={props.theme}
                        stepTab1Data={props.stepTab1Data}
                        stepTab2Data={props.stepTab2Data}
                        sloQuestions={props.sloQuestions}
                        step1DataStore={props.step1DataStore}
                        step2DataStore={props.step2DataStore}
                        step4DataStore={props.step4DataStore}
                        step5Tab1DataStore={props.step5Tab1DataStore}
                        step5Tab2DataStore={props.step5Tab2DataStore}
                        step1CompletionData={props.step1CompletionData}
                        step2CompletionData={props.step2CompletionData}
                        step3CompletionData={props.step3CompletionData}
                        step4CompletionData={props.step4CompletionData}
                        stepCompletionData={props.stepCompletionData}
                        formDisabled={isFormDisabled(props.selectedProgram?.programId, props.stepTab1Data)}
                        defaultTab={props.defaultTab}
                        handleLearningOutcomeChanged={props.handleLearningOutcomeChanged}
                        handleS5Q30Changed={props.handleS5Q30Changed}
                        handleS5Q1Changed={props.handleS5Q1Changed}
                        handleS5Q2Changed={props.handleS5Q2Changed}
                        handleS5Q3Changed={props.handleS5Q3Changed}
                        handleS5Q4Changed={props.handleS5Q4Changed}
                        handleS5Q5Changed={props.handleS5Q5Changed}
                        handleS5Q6Changed={props.handleS5Q6Changed}
                        handleS5Q7Changed={props.handleS5Q7Changed}
                        handleS5Q8Changed={props.handleS5Q8Changed}
                        handleS5Q9Changed={props.handleS5Q9Changed}
                        handleS5Q10Changed={props.handleS5Q10Changed}
                        handleS5Q11Changed={props.handleS5Q11Changed}
                        handleS5Q12Changed={props.handleS5Q12Changed}
                        handleS5Q13Changed={props.handleS5Q13Changed}
                        handleS5Q14Changed={props.handleS5Q14Changed}

                        handleS5Q15Changed={props.handleS5Q15Changed}
                        handleS5Q16Changed={props.handleS5Q16Changed}
                        handleS5Q17Changed={props.handleS5Q17Changed}
                        handleS5Q18Changed={props.handleS5Q18Changed}
                        handleS5Q19Changed={props.handleS5Q19Changed}
                        handleS5Q20Changed={props.handleS5Q20Changed}
                        />
                </div>
                <div className="text-center">
                    <span className="pe-1 text-danger fw-bold">*</span>
                    <span>Indicates required fields</span>
                </div>
            </Modal.Body>

            <Modal.Footer style={{ display: "flex", justifyContent: "center"}}>
                <Button
                    variant="secondary"
                    onClick={handleCancel}
                    className="p-25"
                    >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={handleClose}
                    className="p-25"
                    >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}